const typographyFormParamEquipModel = {
  true: 'Registro de Nuevo Tipo de Equipo',
  false: 'Editar Tipo de Equipo'
};

export default typographyFormParamEquipModel;
